import type { ISaveCurrentUserInfoRequest } from '@treneo/models';
import { formFieldFactory } from '@treneo/shared/forms';

type MyAccountFormData = ISaveCurrentUserInfoRequest & { email?: string };

const myAccountFormField = formFieldFactory<MyAccountFormData>();

export const formFieldNames = {
  email: myAccountFormField('email'),
  firstName: myAccountFormField('firstName'),
  lastName: myAccountFormField('lastName'),
  displayName: myAccountFormField('displayName'),
  avatarColor: myAccountFormField('avatarColor'),
  timezone: myAccountFormField('timezone')
} as const;
